import {
  CREATING_CONTACT_LIST_REQUEST, CREATING_CONTACT_LIST_SUCCEDDED, CREATING_CONTACT_LIST_FAILED,
  UPDATING_CONTACT_LIST_REQUEST, UPDATING_CONTACT_LIST_SUCCEDDED, UPDATING_CONTACT_LIST_FAILED,
  DELETING_CONTACT_LIST_REQUEST, DELETING_CONTACT_LIST_SUCCEDDED, DELETING_CONTACT_LIST_FAILED,
  FETCHING_CONTACT_LIST_REQUEST, FETCHING_CONTACT_LIST_SUCCEDDED, FETCHING_CONTACT_LIST_FAILED,
  FETCHING_CONTACT_LISTS_REQUEST, FETCHING_CONTACT_LISTS_SUCCEDDED, FETCHING_CONTACT_LISTS_FAILED,
  VIEW_CONTACT_LIST, ADD_CONTACT_TO_CONTACTLIST, REMOVE_CONTACT_FROM_CONTACTLIST, DELETING_CONTACT_SUCCEDDED
} from '../actions/actionTypes.jsx';
import _ from 'lodash';

const contactListState = {
  id: 0,
  updating: false,
  deleting: false,
  loading: false,
  item: null
}
const initialState = {
  loading: false,
  invalidated: true,
  creating: false,
  error: null,
  items: [],
  pagination:{
    current: -1,
    totalPages: 1
  },
  contactList: {
    ...contactListState
  }
};



function contactListReducer(state = initialState, action) {
  switch(action.type){  

    case VIEW_CONTACT_LIST:
      var id = action.payload;
      var contactList = state.contactList[id] || contactListState;

      let item = null;
      if (state.items) {
        item = state.items.find(function (contact) {
          return contact.id == id;
        });
      }

      return Object.assign({}, state, {
        ...state,
        contactList: {
          ...state.contactList,
          [id]: {
            ...contactList,
            item: item
          }
        }
      });
    
    case ADD_CONTACT_TO_CONTACTLIST:
      id = action.payload.id;
      var contact = action.payload.contact;

      var contactList = state.contactList[id] || contactListState;

      var index = contactList.item.contacts.findIndex(item => {
        return item.id === contact.id;
      })

      var updatedContactList = [..._.get(contactList,"item.contacts",[]), contact];
      updatedContactList = _.sortBy(updatedContactList,  obj => _.get(obj,"firstName").toLowerCase());

      if(index == -1) {
        return Object.assign({}, state, {
          ...state,
          contactList: {
            ...state.contactList,
            [id]: {
              ...contactList,
              item: {
                ...contactList.item,
                contacts: updatedContactList
              }
            }
          }
        });
      } else {
        return state;
      }

    case REMOVE_CONTACT_FROM_CONTACTLIST:
      id = action.payload.id;
      var contact = action.payload.contact;

      var contactList = state.contactList[id] || contactListState;

      var contacts = contactList.item.contacts.filter((item) => {
        return item.id != action.payload.contact.id;
      });

      contacts = _.sortBy(contacts, obj => _.get(obj,"firstName").toLowerCase());
    

      return Object.assign({}, state, {
        ...state,
        contactList: {
          ...state.contactList,
          [id]: {
            ...contactList,
            item: {
              ...contactList.item,
              contacts: contacts
            }
          }
        }
      });

    case FETCHING_CONTACT_LIST_REQUEST:
      id = action.payload.id;
      var contactList = state.contactList[id] || contactListState;

      return Object.assign({}, state, {
        ...state,
        contactList: {
          ...state.contactList,
          [id]: {
            ...contactList,
            loading: true
          }
        }
      });

    case FETCHING_CONTACT_LIST_SUCCEDDED:
       id = action.payload.id;
      var contactList = state.contactList[id] || contactListState;

      var contacts = action.payload.contactList.contacts || [];
      contacts = contacts.map(item => {
        return {
          ...item,
          persisted: true
        }
      })

      contacts = _.sortBy(contacts, obj => _.get(obj,"firstName").toLowerCase());

      return Object.assign({}, state, {
        ...state,
        contactList: {
          ...state.contactList,
          [id]: {
            ...contactList,
            loading: false,
            item: {
              ...action.payload.contactList,
              contacts: contacts
            }
          }
        }
      });

    case FETCHING_CONTACT_LIST_FAILED:
       id = action.payload.id;
      var contactList = state.contactList[id] || contactListState;

      return Object.assign({}, state, {
        ...state,
        contactList: {
          ...state.contactList,
          [id]: {
            ...contactList,
            loading: false,
            error: action.payload.error
          }
        }
      });

    case CREATING_CONTACT_LIST_REQUEST:
      return Object.assign({}, state, {
        ...state,
        creating: true
      });

    case CREATING_CONTACT_LIST_SUCCEDDED:
       id = action.payload.id;
      var contactList = state.contactList[id] || contactListState;

      var items = state.items.slice();
      items.splice(state.items.length, 0, action.payload);

      items = items.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
     
      return Object.assign({}, state, {
        ...state,
        creating: false,
        items: items,
        contactList: {
          ...state.contactList,
          [id]: {
            ...contactList,
            creating: false,
            item: action.payload
          }
        }
      });

    case CREATING_CONTACT_LIST_FAILED:
      return Object.assign({}, state, {
        ...state,
        creating: false,
        contactList: {
          ...state.contactList,
          error: action.payload
        }
      });

    case UPDATING_CONTACT_LIST_REQUEST:
       id = action.payload;
      var contactList = state.contactList[id] || contactListState;

      return Object.assign({}, state, {
        ...state,
        contactList: {
          ...state.contactList,
          [id]: {
            ...contactList,
            updating: true
          }
        }
      });
    case UPDATING_CONTACT_LIST_SUCCEDDED:
      var id = action.payload.id;
      var contactList = state.contactList[id] || contactListState;
      var newContactList = _.get(action,"payload.contactList");
      newContactList.contacts = _.sortBy(_.get(newContactList,"contacts",[]) , obj => _.get(obj,"firstName").toLowerCase());

      var items = state.items.map((item, index) => {
        if (item.id != id) {
          return item;
        }

        return {
          ...action.payload.contactList
        };
      })
      items = items.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      return Object.assign({}, state, {
        ...state,
        items: items,
        contactList: {
          ...state.contactList,
          [id]: {
            ...contactList,
            updating: false,
            item: newContactList
          }
        }
      });
    case UPDATING_CONTACT_LIST_FAILED:
      id = action.payload.id;
      var contactList = state.contactList[id] || contactListState;

      return Object.assign({}, state, {
        ...state,
        contactList: {
          ...state.contactList,
          [id]: {
            ...contactList,
            updating: false,
            error: action.payload.error
          }
        }
      });

    case DELETING_CONTACT_LIST_REQUEST:
      return Object.assign({}, state, {
        ...state,
        contactList: {
          ...state.contactList,
          deleting: true
        }
      })

    case DELETING_CONTACT_LIST_SUCCEDDED:
      id = action.payload.id;

      return Object.assign({}, state, {
        ...state,
        contactList: {
          ...state.contactList,
          deleting: false,
          id: 0,
          item: null
        },
        items: state.items.filter((contactList, index) => {
          return contactList.id != id;
        })
      })

    case DELETING_CONTACT_LIST_FAILED:
      return Object.assign({}, state, {
        ...state,
        contactList: {
          ...state.contactList,
          deleting: false
        }
      });
    
    case FETCHING_CONTACT_LISTS_REQUEST: 
      return Object.assign({}, state, {
        ...state,
        loading: true,
        invalidated: true
      })
    case FETCHING_CONTACT_LISTS_SUCCEDDED:
      var items = [];

      if (action.payload.currentPage != 0) {
        items = [...state.items, ...action.payload.records];
      } else {
        items = action.payload.records
      }

      items = items.reduce((x, y) => {
        return x.findIndex((e) => {
          return e.id == y.id;
        }) < 0 ? [...x, y] : x
      }, []);

      items = items.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        items: items,
        pagination: {
          ...state.pagination,
          current: action.payload.currentPage,
          totalPages: action.payload.totalPages
        }
      })
    case FETCHING_CONTACT_LISTS_FAILED: 
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error
      })

   

    // case FETCHING_CONTACT_LISTS_SUCCEDDED:
    //   var items = [];

    //   if (action.payload.currentPage != 0) {
    //     items = [...state.items, ...action.payload.records];
    //   } else {
    //     items = action.payload.records
    //   }

    //   items = items.reduce((x, y) => {
    //     return x.findIndex((e) => {
    //       e.id == y.id
    //     }) < 0 ? [...x, y] : x
    //   }, []);

    //   items = items.sort((a, b) => {
    //     return a.name.localeCompare(b.name);
    //   });

    //   return Object.assign({}, state, {
    //     ...state,
    //     loading: false,
    //     invalidated: false,
    //     items: items,
    //     pagination: {
    //       ...state.pagination,
    //       current: action.payload.currentPage,
    //       totalPages: action.payload.totalPages
    //     }
    //   })

    // case FETCHING_CONTACT_LISTS_FAILED:
    //   return Object.assign({}, state, {
    //     ...state,
    //     loading: false,
    //     invalidated: false,
    //     error: action.payload.error
    //   })

    case DELETING_CONTACT_SUCCEDDED:
      var contactId = action.payload.response.id;
      id = action.payload.contactList;
      var index = _.findIndex(state.items, (item) => {
        return item.id == id;
      }, 0);

      var contacts = state.contactList[id].item.contacts.filter((contact) => {
        return contact.id != contactId;
      });

      var items = state.items.map((item, index) => {
        if (item.id != id) {
          return item;
        } else {
          var newItem = {
            ...item,
            contacts: contacts,
            contactCount: state.items[index].contactCount - 1
          }

          return newItem;
        }
      })
      
      items = items.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        items: items,
        contactList: {
          ...state.contactList,
          [id]: {
            ...state.contactList[id],
            item: {
              ...state.contactList[id].item,
              contacts: contacts
            }
          }
        }
      })

    default:
      return state
  }
}

export { contactListReducer };